__turbopack_context__.v({
  "appIcon": "styles-module__rLgOua__appIcon",
  "cardHeader": "styles-module__rLgOua__cardHeader",
  "cardTitle": "styles-module__rLgOua__cardTitle",
  "description": "styles-module__rLgOua__description",
  "desktopCard": "styles-module__rLgOua__desktopCard",
  "dismissButton": "styles-module__rLgOua__dismissButton",
  "downloadCta": "styles-module__rLgOua__downloadCta",
  "minimiseButton": "styles-module__rLgOua__minimiseButton",
  "mobileBanner": "styles-module__rLgOua__mobileBanner",
  "mobileText": "styles-module__rLgOua__mobileText",
  "panel": "styles-module__rLgOua__panel",
  "qrBox": "styles-module__rLgOua__qrBox",
  "root": "styles-module__rLgOua__root",
  "trigger": "styles-module__rLgOua__trigger",
  "triggerLabel": "styles-module__rLgOua__triggerLabel",
});
